import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css"; // Optional: include if you have global styles
import QuizApp from "./QuizApp"; // ✅ Make sure this path is correct

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QuizApp />
  </React.StrictMode>
);
